import type { FC } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { StyledRadioContainer, StyledRadioButton, Container } from "./styledComponents";

type RadioSelectProps = {
    items: { id: string; text: string; tooltip?: string; trackingName?: string; disabled?: boolean }[];
    selected: string;
    className?: string;
    onSelect(id: string): void;
};

const RadioSelect: FC<RadioSelectProps> = (props) => {
    const { items, selected, onSelect } = props;

    return (
        <Container>
            {items.map((item) => (
                <PlainTooltip
                    enabled={!!item.tooltip}
                    tooltipContent={item.tooltip}
                    key={item.id}
                >
                    <StyledRadioContainer>
                        <StyledRadioButton
                            itemDisabled={item.disabled}
                            itemLabel={item.text}
                            onClick={() => onSelect(item.id)}
                            itemSelected={item.id === selected}
                        />
                    </StyledRadioContainer>
                </PlainTooltip>
            ))}
        </Container>
    );
};

export default RadioSelect;
